var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKonnectSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.0836,
    y1: 42.2972,
    x2: 52.1703,
    y2: 3.6258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F00300"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06635137,
    style: {
      stopColor: "#F0230B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    style: {
      stopColor: "#F1531D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2858,
    style: {
      stopColor: "#F1792A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3842,
    style: {
      stopColor: "#F29534"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    style: {
      stopColor: "#F2A53A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5368,
    style: {
      stopColor: "#F2AB3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CD2D1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.9,28.7c0,14.2-11.5,25.7-25.7,25.7S2.6,42.9,2.6,28.7c0-2.5,0.4-4.9,1-7.2c1.7,1.1,3.8,1.8,6,1.8 c6,0,11-4.9,11-11c0-2.7-1-5.2-2.7-7.2c3.2-1.4,6.7-2.2,10.4-2.2C42.4,3.1,53.9,14.6,53.9,28.7z M18.4,12.4c0-4.9-4-8.9-8.9-8.9 s-8.9,4-8.9,8.9s4,8.9,8.9,8.9S18.4,17.3,18.4,12.4z M47.8,6.8c1.8,0,3.3-1.5,3.3-3.3c0-1.8-1.5-3.3-3.3-3.3 c-1.8,0-3.3,1.5-3.3,3.3C44.6,5.3,46,6.8,47.8,6.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.1,28.6L14.1,28.6c0-4.1,3.2-7.5,7.7-7.5s7.6,3.3,7.6,7.4v0c0,4.1-3.2,7.4-7.7,7.4S14.1,32.7,14.1,28.6z M26.1,28.6 L26.1,28.6c0-2.5-1.8-4.6-4.4-4.6c-2.5,0-4.3,2-4.3,4.5v0c0,2.5,1.8,4.5,4.4,4.5S26.1,31.1,26.1,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,33.7l1.9-2.2c1.3,1.1,2.7,1.7,4.3,1.7c1.3,0,2.1-0.5,2.1-1.4v0c0-0.8-0.5-1.2-2.9-1.8c-2.9-0.7-4.8-1.5-4.8-4.4v0 c0-2.6,2.1-4.3,5-4.3c2.1,0,3.9,0.7,5.3,1.8l-1.6,2.4c-1.3-0.9-2.5-1.4-3.7-1.4c-1.2,0-1.9,0.6-1.9,1.3v0c0,0.9,0.6,1.3,3.1,1.9 c2.9,0.8,4.6,1.8,4.6,4.3v0c0,2.9-2.2,4.5-5.3,4.5C35.1,36,32.9,35.2,31.2,33.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKonnectSymbol);
export default __webpack_public_path__ + "static/media/Konnect-Symbol.b85a74639e57fb3180b23d0eb74c0fe2.svg";
export { ForwardRef as ReactComponent };